// Pretty much mapFunc()
const spread = (funcs, ...args) => funcs.map((func) => func(...args));
export const fSpread = (...funcs) => (...args) => funcs.map((func) => func(...args));

export default spread;
